import { call, CallEffect, put, PutEffect, SelectEffect, select } from "redux-saga/effects";
import { AxiosResponse } from "axios";
import moment from "moment";
import { automaticApi } from "@/settings/api";
import { setCustomer } from "@/redux/ducks/customer";
import { ReducersTypes } from "@/redux/reducers/Models";
import { Action } from "redux-saga";

export interface Fetch {
  period: "30" | "60" | "90";
  callback: (success: boolean, data?: ExtractItems) => void;
}

export interface RequestExtractAction {
  type: string;
  payload: Fetch;
}

const uri = "/financial/v1/statement/invoices/items";

export interface ExtractItems {
  items:
    | {
        eventDate: string;
        transactionDate: string;
        usageDescription: string;
        vehiclePlate: string;
        value: string;
        usagePoint: string;
        partner: string;
      }[]
    | null;
}

interface Item {
  eventDate: string;
}

const getCustomerReducer = (state: ReducersTypes) => state.customerReducer;

export default function* requestExtract({
  payload,
}: RequestExtractAction): Generator<
  CallEffect<unknown> | PutEffect<Action> | SelectEffect,
  void,
  AxiosResponse
> {
  try {
    // @ts-expect-error
    const customer: ReducersTypes["customerReducer"] =
      yield select(getCustomerReducer);

    const initialDate = moment()
      .subtract(payload.period, "days")
      .format("YYYY-MM-DD");
    const finalDate = moment().format("YYYY-MM-DD");

    const res = yield call(automaticApi.get, uri, {
      params: {
        initialDate: initialDate,
        finalDate: finalDate,
      },
    });

    if (res?.data?.serviceMessage?.codigoRetorno === 0) {
      yield put(
        setCustomer({
          extract: {
            ...customer?.extract,
            lastUpdated: new Date(),
          },
        }),
      );
      const sortedItems = res?.data?.listStatementItem?.sort(
        (a: Item, b: Item) => {
          const dateA = moment(a.eventDate);
          const dateB = moment(b.eventDate);

          return dateB.valueOf() - dateA.valueOf();
        },
      );
      yield call(payload.callback, true, sortedItems);
    } else {
      yield call(payload.callback, false);
    }
  } catch (error) {
    yield call(payload.callback, false);
  }
}
